export default __webpack_public_path__ + "static/media/file-upload.8503e692.svg";